import { ChangeDetectorRef, Component, ComponentFactoryResolver, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { SolarBaseComponent } from '@solar/solar/solar-base';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Site, InfoSite, Supervision, User } from 'solar-bo';;
import { AppConfig } from '@solar/app.config';
import { MessageError } from 'base-models';
import { AlertType } from 'base-models';
import { CountryPickerService, ICountry } from 'basecomponents';
import { DialogdeleteComponent } from 'basecomponents';
import { SortHelper } from 'shtools';
import { ErrorcontrolService } from 'basecomponents';

import { TableList } from 'shtools';
import { TabComponent } from '@solar/components/maintab/tab.component';
import { MainTabComponent } from '@solar/components/maintab/maintab.component';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { TabItem } from '@solar/components/maintab/tabitem.model';
import { UserDetailComponent } from '../user-detail/user-detail.component';




@Component({
  selector: 'app-user-list-main',
  templateUrl: './user-list-main.component.html',
  styleUrls: ['./user-list-main.component.scss']
})
export class UserListMainComponent extends SolarBaseComponent implements OnInit {

  tabsComponents: TabItem[] = [];
  tab_selectedIndex = 0;
  //@ViewChild(MainTabComponent) tabsComponent:MainTabComponent;

  @ViewChild(MatTabGroup, { read: MatTabGroup }) public tabGroup: MatTabGroup;
  @ViewChildren(MatTab, { read: MatTab }) public tabNodes: QueryList<MatTab>;
  //@ViewChild('tablistcomp') tablistComp: TabsetComponent;


  constructor(private cdr: ChangeDetectorRef) {
    super();
    this.loading = false;
    this.routeConfigEventsHandler();
  }

  ngOnInit() {


  }

  private routeConfigEventsHandler(){
    this.router.events.subscribe((routeEvent) => {

      //no sirve con ReuseStrategy, esta activo todo el tiempo
/*       if (routeEvent instanceof NavigationEnd){
        console.log("NavigationEnd--------------" , routeEvent ); //instanceof NavigationEnd
      } else if (routeEvent instanceof NavigationStart && routeEvent.url == (this.route1 as any)._routerState.snapshot.url){
        console.log("NavigationStart------------------" , routeEvent ); 
      } */
      console.log("navigation router.events:" , routeEvent );
      //console.log("navigation ActivatedRoute:" , this.route1);
      //NavigationStart
      // NavigationEnd
    // NavigationCancel
    // NavigationError
    // RoutesRecognized
  });
  }
 

  userSelectedEventHandler($event) {
    let user: User = $event;
    //this.tabsComponent.openTab(site.name, SiteMainComponent, {siteId:site.id}, true);
    let tabExistIndex = this.findTabBy(user.id);
    if (tabExistIndex > -1) {
      this.tabGroup.selectedIndex = tabExistIndex + 1;//because we have at least 1 fixed we use total length
      return;
    }
    this.loadinglist = true;
    //setTimeout(() => this.loadinglist=true);    
    //this.cdr.detectChanges();
    setTimeout(() =>
      this.openTab(user.id, user.name, UserDetailComponent, { id_user: user.id }, true)
    );

  }

  userDeletedEventHandler($event) {
    let user: User = $event;
    let tabExistIndex = this.findTabBy(user.id);
    if (tabExistIndex > -1) {
      this.closeTab(tabExistIndex);
      return;
    }
  }

  openTab(id: any, title: string, component, data, isCloseable = false) {

    let instance: TabItem = new TabItem();
    instance.id = id;
    instance.title = title;
    instance.component = component;
    instance.dataContext = data;
    instance.active = true;
    instance.isCloseable = isCloseable;
    this.tabsComponents.push(instance);
    this.tabGroup.selectedIndex = this.tabsComponents.length;//because we have at least 1 fixed we use total length
    this.loadinglist = false;
    return instance;

  }

  private findTabBy(id: any) {
    let index = this.tabsComponents.findIndex(item => item.id == id);
    return index;
  }

  closeTab(index: number, tab?: any) {
    event.stopPropagation();
    this.tabsComponents.splice(index, 1);
    this.tabGroup.selectedIndex = this.tabNodes.length - 1;
  }

  onSelectTab($event) {
    switch ($event.id) {
      case "tab_sitelist":

        break;
    }
  }


}
